/**
 * Perbaikan untuk bug di plugin WooCommerce MultiStep Checkout (JANGAN
 * diperbaiki dengan mengubah file plugin - perubahan di plugin/parent theme
 * dilarang, semua fix harus lewat child theme ini).
 *
 * Bug plugin: manipulate_login_form() / manipulate_coupon_form() di
 * js/wizard.js plugin itu mengecek `jQuery(".login-step").hasClass("current")`
 * untuk tahu apakah step Login sedang aktif. Class "current" itu sebenarnya
 * dipasang jQuery Steps di elemen pembungkus `div.body`, bukan di
 * `.login-step` sendiri - jadi pengecekan itu selalu false, dan tiap kali
 * step wizard berganti (event custom "onStepChanged" yang di-trigger di
 * `#wizard`), form login/kupon selalu dipindah + disembunyikan ke
 * `.container-coupon-login-form` (yang di-CSS plugin itu `display:none`
 * permanen) - termasuk saat usernya justru sedang pindah KE step Login/Kupon.
 *
 * Ini menyebabkan dua gejala:
 * 1. Klik tab "Login" malah menyembunyikan form loginnya.
 * 2. Link "Please log in" pada notice checkout ("An account is already
 *    registered...") tidak kelihatan efeknya - WooCommerce core toggle
 *    formnya, tapi formnya sudah terlanjur ada di dalam container yang
 *    display:none.
 *
 * Fix di sini tidak menyentuh file plugin sama sekali. `#wizard` men-trigger
 * event custom "onStepChanged" pada dirinya sendiri, dan handler plugin
 * (di-bind langsung ke `#wizard`) selalu jalan lebih dulu sebelum event itu
 * "bubble" ke leluhurnya - jadi handler tambahan yang di-bind ke `document`
 * di bawah ini DIJAMIN jalan SETELAH handler plugin, apa pun urutan enqueue
 * script-nya. Begitu plugin selesai menyembunyikan form ke tempat yang
 * salah, handler ini mengoreksinya: kalau step yang sedang aktif memang
 * berisi .login-step/.coupon-step, pindahkan formnya kembali ke sana dan
 * tampilkan - persis logika yang plugin itu MAKSUDKAN tapi salah selector.
 */
function fixMultistepFormVisibility() {
  var $ = window.jQuery;
  if (!$) return;

  var wmcWizard = window.wmc_wizard || {};
  var $current = $("#wizard div.body.current");
  if (!$current.length) return;

  var useFade = wmcWizard.transitionEffect === "fade";

  var $loginStep = $current.find(".login-step");
  if ($loginStep.length) {
    var loginSelector =
      wmcWizard.include_register_form === "true"
        ? "#customer_login"
        : "form.woocommerce-form-login";
    var $loginForm = $(loginSelector).appendTo($loginStep);
    useFade ? $loginForm.fadeIn(100) : $loginForm.slideDown(100);
  }

  var $couponStep = $current.find(".coupon-step");
  if ($couponStep.length) {
    var $couponForm = $("form.checkout_coupon").appendTo($couponStep);
    useFade ? $couponForm.fadeIn(100) : $couponForm.slideDown(100);
  }
}

/**
 * Notice checkout bawaan WooCommerce ("An account is already registered
 * with your email address. Please log in.") berisi link `a.showlogin` yang
 * defaultnya cuma slideToggle() form login di tempat dia berada - percuma
 * kalau formnya ada di step wizard yang sedang tersembunyi.
 *
 * Klik pada `a.showlogin` di sini dialihkan untuk memindahkan wizard ke tab
 * "Login" (mensimulasikan klik user ke tab #wizard-t-0, id tab pertama dari
 * jquery.steps), supaya validasi & transisi bawaan wizard tetap jalan
 * seperti biasa, ketimbang toggle bawaan WooCommerce yang tidak kelihatan
 * efeknya. Ditangkap di fase capture pada document supaya jalan lebih dulu
 * daripada listener bawaan WooCommerce (wc_checkout_login_form di
 * checkout.js, didelegasikan ke document.body pada fase bubble) - jadi bisa
 * membatalkan toggle bawaan tanpa mengubah file plugin WooCommerce.
 *
 * Kalau wizard-nya tidak ada (mis. checkout tanpa plugin multistep aktif),
 * event dibiarkan lanjut supaya toggle bawaan WooCommerce tetap jalan
 * sebagai fallback.
 */
function bindShowLoginRedirect() {
  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest("a.showlogin");
      if (!link) return;

      var loginTab = document.getElementById("wizard-t-0");
      if (!loginTab) return;

      event.preventDefault();
      event.stopPropagation();
      loginTab.click();
    },
    true
  );
}

export function initCheckoutLoginRedirect() {
  var $ = window.jQuery;
  if ($) {
    $(document).on("onStepChanged", fixMultistepFormVisibility);
  }

  bindShowLoginRedirect();
}
